/**
 *  Initialize privacy cookie and message display
 *
 *  Example Javascript module with self-contained object interface.
 */
var privacyCookie = (function () {

  // Show privacy cookie message if cookie not set.
  // Hide message then set privacy cookie if message box x/close is clicked.

  /* eslint-disable no-new */
  new Vue({
    el: '#cookieMessage',
    data: {
      eastViewAcceptedCookie: false
    },
    methods: {
      xClick() {
        document.cookie = 'eastViewAcceptedCookie=true';
        this.eastViewAcceptedCookie = true;
      }
    },
    created() {
      const cookies = document.cookie.split('; ');

      for (let i = 0; i < cookies.length; i++) {
        const thisCookie = cookies[i].split('=');

        if (thisCookie[0] === 'eastViewAcceptedCookie') {
          this.eastViewAcceptedCookie = true;
        }
      }
    }
  });

  var pub = {}; // public facing functions

  pub.init = function () {

  };

  return pub;

}());
